/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HubIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA7UlEQVR4nOWUPQ7CMAyFs/QWMHOaOOmAbIk9Z6GUk6BKTHAlfiSQ4AKgkAZICyRK0wGw5KXPzZfY8mPsL0IplYHEORe40wmSSv0tGQAklSDp4iYWyQDc3LoJ2PYLELRJCKBZ+wU0TQZQSmUuBIukQ7ZhAayvgK8BCIFDkFhxSecXw3XS1OASYDwKPpwLOvgOhvZeHPW/AW3AytwMV3k+GfhapGtA0LrejYUXYNvSPPzTDExLb684sS6DhEjtyTEfpqYXyy5TrOZ1TF3cRXMBgvbvDA0itWBL5pFasGPySK01ZFOM2zrvjqkitd+IK64OaSHRHc74AAAAAElFTkSuQmCC)
 */
export const HubIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13 7.83a3 3 0 1 0-2 0V11H8a4 4 0 0 0-4 4v1.17a3 3 0 1 0 2 0V15c0-1.1.9-2 2-2h3v3.17a3 3 0 1 0 2 0V13h3a2 2 0 0 1 2 2v1.17a3 3 0 1 0 2 0V15a4 4 0 0 0-4-4h-3V7.83Z"
        className={colorClass}
      />
    </svg>
  );
};
